import {ReactBaseComponent} from '../../../react/base/react-base.component';
import {Component, ElementRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {CalculationGoldList} from '../../../react/calculation/gold/calculation-gold-list';
import {ErpAngularZonedRouterService} from '../../../react/components/react-router/erp-angular-zoned-router.service';
import {
  ErpReactUiRouterContextWrapper,
} from '../../../react/components/react-router/erp-react-ui-router-context-wrapper';
import {ErpAlertContext} from '../../../react/components/react-angular-alert/erp-react-alert-context';
import {
  ErpAngularZonedAlertService,
} from '../../../react/components/react-angular-alert/erp-angular-zoned-alert.service';

const containerElementName = 'reactMultilayerPlanContainer';

@Component({
  selector: 'calculation-gold-list',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `<div #${containerElementName}></div>`,
})
export class CalculationGoldListComponent extends ReactBaseComponent {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;

  constructor(private angularRouterService: ErpAngularZonedRouterService,
              private alertService: ErpAngularZonedAlertService) {
    super();
  }

  protected renderComponent() {
    return <ErpReactUiRouterContextWrapper context={this.angularRouterService?.context() ?? null}>
      <ErpAlertContext.Provider value={{context: this.alertService.context()}}>
        <CalculationGoldList stateName="a.calculation.gold"/>
      </ErpAlertContext.Provider>
    </ErpReactUiRouterContextWrapper>;
  }
}
